export const FormHelperText = {
  defaultProps: {
    lineHeight: '21px',
  },
}
